<template>
  <div class="goodsInfo" @click="onClickItem(item)">
    <div :class="['imageInfo', item.is_sell_out==1?'greyImage':'']">
      <QualityImg :src="item.img_url" width="348" height="348" />
      <div v-if="item.is_sell_out==1" class="sellout">
        <span>已售罄</span>
      </div>
    </div>
    <div class="nameInfo">
      {{item.goods_name}}
    </div>
    <div class="priceInfo">
      <span>￥</span>
      <span>{{item.price | money}}</span>
      <span v-if="!item.sstore_id">起</span>
    </div>
    <slot name="bottom"></slot>
  </div>
</template>
<script>
import QualityImg from '@/components/qualityImg/qualityImg.vue'
export default {
    name: 'distributionGoodsItem',
    data () {
        return {

        }
    },
    components:{
        QualityImg
    },
    props: {
        item: {
            type: Object,
            default () {
                return {}
            }
        }
    },
    methods: {
        onClickItem (item) {
            this.$emit('onClickItem', item)
        }
    }
}
</script>
<style lang="stylus" scoped>
.goodsInfo
  // width 348px
  width px2vw(348)
  background #fff
  box-sizing content-box
  border-radius px2vw(20)
  overflow hidden
  padding-bottom px2vw(31)
  margin-bottom px2vw(14)
  .imageInfo
    width 100%
    height px2vw(348)
    position relative
    display flex
    align-items center
    img
      width 100%
  .greyImage
    >>> .van-image
      img
        filter grayscale(100%)
    img
      filter grayscale(100%)
    .sellout
      position absolute
      background rgba(0,0,0,.5)
      display flex
      width px2vw(140)
      height px2vw(140)
      justify-content center
      align-items center
      color #ffffff
      font-size px2vw(36)
      z-index 99
      border-radius px2vw(100)
      left 50%
      top 50%
      transform translate(-50%,-50%)
  .nameInfo
    margin px2vw(21)
    font-size px2vw(24)
    color #333333
    min-height px2vw(53)
    -webkit-box-pack center
    mutiLineTextOverFlow(2)
    line-height 1.2
  .priceInfo
    padding 0 px2vw(20)
    color #fc2d2d
    > span:nth-of-type(1)
      font-size px2vw(24)
    > span:nth-of-type(2)
      font-size px2vw(30)
    > span:nth-of-type(3)
      font-size px2vw(20)
</style>
